import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { USERS_EDIT } from 'src/store/ActionTypes';
import * as api from 'src/store/api';

function* fetchUser(action) {
  try {
    const user = yield call(api.getUser, action.payload);
    yield put({
      type: USERS_EDIT.FETCH_USER_SUCCEEDED,
      payload: user,
    });
  } catch (e) {
    yield put({
      type: USERS_EDIT.FETCH_USER_FAILED,
      payload: e.message,
    });
  }
}

function* editUser(action) {
  try {
    const { userId, user } = action.payload;
    yield call(api.editUser, userId, user);
    yield put({
      type: USERS_EDIT.EDIT_USER_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: USERS_EDIT.EDIT_USER_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: USERS_EDIT.UNSET,
      payload: 'editUserStatus',
    });
  }
}

function* resendInvitation(action) {
  try {
    yield call(api.resendInvitation, action.payload);
    yield put({
      type: USERS_EDIT.RESEND_INVITATION_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: USERS_EDIT.RESEND_INVITATION_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: USERS_EDIT.UNSET,
      payload: 'resendInvitationStatus',
    });
  }
}

function* resetPassword(action) {
  try {
    yield call(api.resetPassword, action.payload);
    yield put({
      type: USERS_EDIT.RESET_PASSWORD_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: USERS_EDIT.RESET_PASSWORD_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: USERS_EDIT.UNSET,
      payload: 'resetPasswordStatus',
    });
  }
}

function* fetchUserSaga() {
  yield takeLatest(USERS_EDIT.FETCH_USER, fetchUser);
}

function* editUserSaga() {
  yield takeLatest(USERS_EDIT.EDIT_USER, editUser);
}

function* resendInvitationSaga() {
  yield takeLatest(USERS_EDIT.RESEND_INVITATION, resendInvitation);
}

function* resetPasswordSaga() {
  yield takeLatest(USERS_EDIT.RESET_PASSWORD, resetPassword);
}

export default [fetchUserSaga(), editUserSaga(), resendInvitationSaga(), resetPasswordSaga()];
